import React, { useState } from 'react'
import { Col, Container, FormControl, InputGroup, Row, Spinner } from 'react-bootstrap'

import { uploadReceipt } from '../../services/files'
import { updatePackage } from '../../services/packages'

export default function UploadFileOffice(props) {
  const { itemId, useForceUpdate } = props
  const [isLoading, setIsLoading] = useState(false)
  const x = useForceUpdate
  const onChange = async e => {
    const file = e.target.files[0]

    try {
      setIsLoading(true)
      const result = await uploadReceipt(file, itemId)
      console.log('UploadFileOffice - result:', result)

      await updatePackage(itemId, {
        buyingReciptKey: result.Location,
      })

      x()
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('Error uploading file: ', error)
      alert(`Error! ${error.response.data?.msg}`)
    }
  }

  return (
    <div>
      {isLoading ? (
        <Container>
          <Spinner animation='border' variant='primary' />
        </Container>
      ) : (
        <Container>
          <Row>
            <Col
              style={{
                marginRight: 'auto',
                marginLeft: 'auto',
                marginTop: '1rem',
                marginBottom: '1rem',
                textAlign: 'center',
              }}
            >
              <h3 style={{ color: '#00aeef' }}> העלאת קבצים</h3>
            </Col>
          </Row>

          <InputGroup className='mb-3'>
            <InputGroup.Prepend>
              <InputGroup.Text id='inputGroup-sizing-default'>בחר את קובץ הקבלה</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl onChange={onChange} type='file' aria-label='Default' aria-describedby='inputGroup-sizing-default' />
          </InputGroup>
        </Container>
      )}
    </div>
  )
}
